import { useState } from 'react';
import { Link } from 'react-router-dom';
import './HelpPage.css';

const faqs = [
  {
    q: 'NoteSwapp nedir?',
    a: 'NoteSwapp, üniversite öğrencilerinin ders notlarını adil, organize ve güvenilir bir şekilde paylaşmasına yardımcı olan bir not paylaşım platformudur. Yapay zeka destekli kalite kontrolleri ve dengeli değiş tokuş sistemi ile öğrenciler hem not paylaşabilir hem de ihtiyaç duydukları notlara ulaşabilir.',
  },
  {
    q: 'Nasıl not yükleyebilirim?',
    a: 'Uygulamayı indirdikten sonra hesabınızı oluştururun, ardından "Not Yükle" butonuna tıklayarak ders notunuzu PDF veya görsel formatında yükleyebilirsiniz. Notunuz yapay zeka tarafından kalite kontrolünden geçtikten sonra diğer öğrencilerle paylaşıma açılır.',
  },
  {
    q: 'Nasıl not bulabilirim?',
    a: 'Aradığınız dersi ilan olarak ekleyip kendi notunuzu sisteme yükleyebilirsiniz. Sistem, öğrencilerin yüklediği notları ve aradığı dersleri karşılaştırır. Karşılıklı uygunluk olduğunda eşleşme oluşur ve iki taraf da aradığı nota erişebilir.',
  },
  {
    q: 'Yüklenen notlar neden kontrol edilir?',
    a: 'NoteSwapp, kaliteli ve güvenilir içerik sunmayı öncelik olarak benimsemiştir. Yapay zeka destekli kontrol sistemi; notların akademik içerik açısından tutarlılığını, okunabilirliğini ve uygunluğunu değerlendirerek düşük kaliteli veya yanıltıcı içeriklerin paylaşılmasını engeller.',
  },
  {
    q: 'Notum kalite kontrolünden geçmezse ne olur?',
    a: 'Notunuz okunabilir değilse, eksikse, dersle ilgisizse veya uygunsuz içerik barındırıyorsa kalite kontrolünden geçmeyebilir. Bu durumda notunuz sistemde yayınlanmaz. Gerekli düzenlemeleri yaptıktan sonra notunuzu tekrar yükleyebilirsiniz.',
  },
  {
    q: 'NoteSwapp kullanımı ücretsiz mi?',
    a: 'Evet, NoteSwapp temel özellikleriyle tamamen ücretsizdir. Not yükleme, arama ve değiş tokuş sistemi hiçbir ücret gerektirmez. İleride sunulabilecek ek özellikler için farklı planlar değerlendirilebilir.',
  },
  {
    q: 'Bir sorunu veya uygunsuz içeriği nasıl bildirebilirim?',
    a: 'Uygunsuz bir not, hatalı içerik, kullanıcı problemi veya teknik bir sorun bildirmek için noteswapp@gmail.com adresine e-posta gönderebilirsiniz. Mesajınızda sorunu açıkça anlatmanız ve mümkünse ekran görüntüsü eklemeniz inceleme sürecini hızlandırır.',
  },
  {
    q: 'Hesabımı nasıl silebilirim?',
    custom: true,
  },
  {
    q: 'Nasıl destek alabilirim?',
    a: 'Destek için geri bildirim sayfamızı kullanarak bize ulaşabilirsiniz. Sorularınızı ve sorunlarınızı ilettiğinizde en kısa sürede geri dönüş yapacağız.',
  },
];

const categories = [
  { label: 'Tümü', value: 'all' },
  { label: 'Genel', value: 'genel' },
  { label: 'Not Yükleme', value: 'yukleme' },
  { label: 'Değiş Tokuş', value: 'degis' },
  { label: 'Güvenlik', value: 'guvenlik' },
];

function FAQItem({ q, a, children }) {
  const [open, setOpen] = useState(false);
  return (
    <div className={`faq-item${open ? ' faq-item--open' : ''}`}>
      <button className="faq-item__question" onClick={() => setOpen(o => !o)}>
        <span>{q}</span>
        <span className="faq-item__icon">
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
            <path
              d={open ? 'M5 13l5-5 5 5' : 'M5 7l5 5 5-5'}
              stroke="#5784E6"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </span>
      </button>
      {open && (
        <div className="faq-item__answer">
          {children || <p>{a}</p>}
        </div>
      )}
    </div>
  );
}

export default function HelpPage() {
  const [activeCategory, setActiveCategory] = useState('all');
  const [search, setSearch] = useState('');

  const filtered = faqs.filter(f =>
    f.q.toLowerCase().includes(search.toLowerCase()) ||
    (f.a && f.a.toLowerCase().includes(search.toLowerCase())) ||
    (f.custom && 'hesap silme veri'.includes(search.toLowerCase()))
  );

  return (
    <div className="help-page">
      {/* Hero */}
      <section className="help-hero">
        <div className="container">
          <div className="help-hero__tag">Yardım Merkezi</div>
          <h1 className="help-hero__title">Yardım &amp; SSS</h1>
          <p className="help-hero__subtitle">
            NoteSwapp ve nasıl çalıştığı hakkında sık sorulan soruların cevaplarını bulun.
          </p>

          {/* Search */}
          <div className="help-search">
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
              <circle cx="9" cy="9" r="6" stroke="#7A8BAD" strokeWidth="1.8"/>
              <path d="M13.5 13.5L17 17" stroke="#7A8BAD" strokeWidth="2" strokeLinecap="round"/>
            </svg>
            <input
              type="text"
              placeholder="Soru veya konu ara..."
              value={search}
              onChange={e => setSearch(e.target.value)}
            />
            {search && (
              <button className="help-search__clear" onClick={() => setSearch('')}>✕</button>
            )}
          </div>

          {/* Categories */}
          <div className="help-categories">
            {categories.map(cat => (
              <button
                key={cat.value}
                className={`help-cat${activeCategory === cat.value ? ' help-cat--active' : ''}`}
                onClick={() => setActiveCategory(cat.value)}
              >
                {cat.label}
              </button>
            ))}
          </div>
        </div>
      </section>

      {/* FAQ List */}
      <section className="help-faq">
        <div className="container">
          {filtered.length > 0 ? (
            <>
              <p className="help-faq__count">{filtered.length} sonuç bulundu</p>
              <div className="help-faq__list">
                {filtered.map((faq, i) =>
                  faq.custom ? (
                    <FAQItem key={i} q={faq.q}>
                      <p>
                        Hesabınızı veya verilerinizi silmek için{' '}
                        <Link to="/hesap-silme">Hesap ve Veri Silme Talebi</Link> sayfamızdaki adımları
                        izleyebilirsiniz. Kısaca: <a href="mailto:noteswapp@gmail.com?subject=NoteSwapp%20Hesap%20Silme%20Talebi">noteswapp@gmail.com</a>{' '}
                        adresine &quot;NoteSwapp Hesap Silme Talebi&quot; konu başlığıyla, hesabınızda kullandığınız
                        e-posta adresini belirterek yazmanız yeterlidir.
                      </p>
                    </FAQItem>
                  ) : (
                    <FAQItem key={i} q={faq.q} a={faq.a} />
                  )
                )}
              </div>
            </>
          ) : (
            <div className="help-faq__empty">
              <svg width="56" height="56" viewBox="0 0 56 56" fill="none">
                <circle cx="28" cy="28" r="26" fill="#EEF2FD"/>
                <path d="M28 20v10M28 36v2" stroke="#5784E6" strokeWidth="2.5" strokeLinecap="round"/>
              </svg>
              <p>"{search}" için sonuç bulunamadı.</p>
              <button onClick={() => setSearch('')}>Aramayı temizle</button>
            </div>
          )}
        </div>
      </section>

      {/* Still have questions CTA */}
      <section className="help-cta">
        <div className="container">
          <div className="help-cta__box">
            <div className="help-cta__icon">
              <svg width="40" height="40" viewBox="0 0 40 40" fill="none">
                <circle cx="20" cy="20" r="18" fill="#EEF2FD"/>
                <path d="M20 13c-3.31 0-6 2.69-6 6 0 2.22 1.21 4.15 3 5.19V27l2-1 2 1.5 2-1.5 2 1v-2.81A6 6 0 0026 19c0-3.31-2.69-6-6-6z" fill="#5784E6" opacity=".3"/>
                <path d="M20 15v5l3 2" stroke="#5784E6" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </div>
            <h2 className="help-cta__title">Hala Sorularınız mı Var?</h2>
            <p className="help-cta__desc">
              Aradığınızı bulamadıysanız, geri bildirim sayfamız üzerinden sorunuzu bize göndermekten çekinmeyin.
            </p>
            <a href="/feedback" className="help-cta__btn">
              Geri Bildirim Gönder
            </a>
          </div>
        </div>
      </section>
    </div>
  );
}
